// extracted by mini-css-extract-plugin
export default {"blockwrapper":"TS","header":"US","name":"VS","columns":"WS","imagewrapper":"XS","addinfo":"YS","description":"ZS","price":"aT","old":"bT","new":"cT","desc_d":"eT","infoblock":"fT","desc_m":"gT"};
    if(module.hot) {
      // 1730991509262
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  